module.exports = __webpack_public_path__ + "img/794.f67f6117.gif";